<template>
 <v-container class="d-flex align-center justify-center error-container text-center">
    <v-card class="mx-auto" max-width="600" min-width="400" align="center" justify="center">
      <div class="py-16 px-8 ">
        <v-row justify="center" class="my-5 pa-0 error-content">
          <v-col cols="12" class="text-center my-5 pa-0">
            <img
              :src="$theme.sessaoExpirada"
              alt="Ícone de sessão expirada"
              class="error-image"
              width="100"
              height="100"
            />
          </v-col>
        </v-row>
        <v-card-text class="text-center pa-0 ma-0">
          <div class="error-title">
            <h2>Sessão Expirada</h2>
          </div>
          <div class="error-subtitle">
            Sua sessão expirou. Por favor, tente novamente.
          </div>
        </v-card-text>
      </div>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="#1A1889"
          @click="redirectToLogin"
          class="rounded-btn white--text"
          :max-height="40"
        >
          Voltar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
export default {
  methods: {
    redirectToLogin () {
      const th = this;
      const targetWindow = window.parent ?? window.top ?? window.opener ?? window;
      targetWindow.postMessage('multiplo.propostaFinalizada', '*')
      th.$api.UTIL.Auth.Logout();
    },
  },
}
</script>

<style scoped>
.error-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.error-content {
  text-align: center;
}
.error-image {
  max-width: 100%;
  font-family: 'Roboto', sans-serif;
}
.error-subtitle {
  margin-top: 30px;
  font-family: 'Roboto', sans-serif;
}
.error-title {
  font-size: 2em;
  font-weight: bold;
  font-weight: 700;
  font-family: 'Roboto', sans-serif;
}
.rounded-btn {
  border-radius: 5px;
  color: #FFFFFF;
  font-family: 'Roboto', sans-serif;
}
</style>
